const TVActionTypes = {
  SET_TV_DATA: 'SET_TV_DATA',
  SET_TV_GRID_DATA: 'SET_TV_GRID_DATA',
  SET_TV_DATA_SUCCESS: 'SET_TV_DATA_SUCCESS',
  SET_TV_ADDITIONAL_DATA: 'SET_TV_ADDITIONAL_DATA'

};

export default TVActionTypes;